import { useState } from "react"

import { neloApiClient } from "@lib/config-client"

const useSendWhatsappLink = () => {
  const [isWhatsappLinkLoading, setIsWhatsappLinkLoading] = useState<boolean>(false)
  const [error, setError] = useState<string | null>(null)

  const sendWhatsappVerificationLink = async (productTitle?: string) => {
    setIsWhatsappLinkLoading(true)
    setError(null)
    try {
      const response = await neloApiClient.sendWhatsappVerificationLink(productTitle)
      return response
    } catch (error) {
      setError("Hubo un error al enviar el mensaje. Por favor, intenta nuevamente.")
      throw error
    } finally {
      setIsWhatsappLinkLoading(false)
    }
  }

  return {
    sendWhatsappVerificationLink,
    isWhatsappLinkLoading,
    error,
  }
}

export default useSendWhatsappLink
